class DecLocalFormat extends HTMLInputElement {
  static get DECIMAL_SEPARATOR () {
    return new Intl.NumberFormat(navigator.language).format(9.9).replace(/9/g, '')
  }

  connectedCallback () {
    // No asignamos `pattern` por el mismo motivo que IntLocalFormat: un `pattern` de dígitos
    // sobre un <input type="text"> dispara la heurística OTP de Safari/WebKit y de la extensión
    // iCloud Passwords, que saca el popup del gestor de contraseñas encima de los campos de
    // importe. `autocomplete="off"` no lo evita; quitar el `pattern` sí (ENH-RNK-2854).
    this.addEventListener('input', () => {
      if (this.value !== '') {
        const original = this.originalValue()
        if (isNaN(original)) {
          this.value = this.value.slice(0, -1)
        } else {
          this.value = this.value.replace(/[,.]/g, DecLocalFormat.DECIMAL_SEPARATOR)
        }
      }
    })
  }

  originalValue () {
    return this.value.replace(new RegExp(`[${DecLocalFormat.DECIMAL_SEPARATOR}]`, 'g'), '')
  }
}

export default DecLocalFormat
